// Collixl-loaderen: de fire grønne C-ringene som tegnes inn og samles til
// symbolet. Felles laste-ikon der data hentes — sider, seksjoner, grafer og
// tabeller — som i Ctrl. Små tilstander står som før: knapper («Lagrer…»,
// «Synker…»), antall i overskrifter, nedtrekkslister og verdiplassholderen i
// KPI-kortene.
//
// Fila vises med <img>: animasjonen bor i SVG-en selv, fila caches én gang for
// hele appen, og SVG-en stopper animasjonen ved prefers-reduced-motion.

export const LASTEIKON_URL = '/brand/colliloader.svg'

const STORRELSER = {
  side: { px: 96, plass: 'py-16' },
  seksjon: { px: 64, plass: 'py-10' },
  rad: { px: 40, plass: 'py-4' },
}

/**
 * @param storrelse 'side' (96 px), 'seksjon' (64 px) eller 'rad' (40 px, tabellrader og små felt)
 * @param tekst     vises under ikonet når den sier mer enn «Laster» (f.eks. «Henter prisliste…»)
 * @param className erstatter standardluften rundt ikonet, f.eks. 'h-72' for å holde høyden til en graf
 */
export function Lasteikon({ storrelse = 'seksjon', tekst, className }) {
  const { px, plass } = STORRELSER[storrelse] || STORRELSER.seksjon
  return (
    <div role="status" className={`flex flex-col items-center justify-center gap-3 text-center text-sm text-text-muted ${className ?? plass}`}>
      <img src={LASTEIKON_URL} alt="" width={px} height={px} draggable="false" className="select-none shrink-0" />
      {tekst ? <span>{tekst}</span> : <span className="sr-only">Laster…</span>}
    </div>
  )
}

/** Hele skjermen, mens innloggingen avklares. */
export function Lasteside({ tekst }) {
  return (
    <div className="min-h-screen bg-bg flex items-center justify-center">
      <Lasteikon storrelse="side" tekst={tekst} className="" />
    </div>
  )
}
